import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const DatePickerCalendarIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M18.984 20.0288V8.99519H5.016V20.0288H18.984ZM18.984 3.97115C19.528 3.97115 20 4.17147 20.4 4.57212C20.8 4.97276 21 5.44551 21 5.99038V20.0288C21 20.5737 20.8 21.0385 20.4 21.4231C20 21.8077 19.528 22 18.984 22H5.016C4.456 22 3.98 21.8077 3.588 21.4231C3.196 21.0385 3 20.5737 3 20.0288V5.99038C3 5.44551 3.196 4.97276 3.588 4.57212C3.98 4.17147 4.456 3.97115 5.016 3.97115H6V2H8.016V3.97115H15.984V2H18V3.97115H18.984ZM17.016 11.0144V12.9856H15V11.0144H17.016ZM12.984 11.0144V12.9856H11.016V11.0144H12.984ZM9 11.0144V12.9856H6.984V11.0144H9Z'
                fill='currentColor'
            />
        </>
    ),
})

DatePickerCalendarIcon.displayName = 'DatePickerCalendarIcon'
